import type { FC } from 'react';
import { Skeleton } from '@chakra-ui/react';

/**
 * Skeleton component for breadcrumbs.
 * Mimics the appearance of breadcrumbs with 2-3 items to prevent layout shift.
 */
export const BreadcrumbSkeleton: FC = () => (
    <div className="hidden justify-start px-4 sm:px-0 md:flex" data-testid="breadcrumb-skeleton">
        <Skeleton height="22px" width="200px" borderRadius="0" />
    </div>
);
